import React from 'react';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <h3 className="footer-title">Arauclin</h3>
          <p className="footer-subtitle">Excelência em Medicina e Segurança do Trabalho desde 1995</p>
          <p className="footer-copyright">&copy; 2025 Arauclin. Todos os direitos reservados.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;